import { render, staticRenderFns } from "./ClassFilterNav.vue?vue&type=template&id=a4e63876"
import script from "./ClassFilterNav.vue?vue&type=script&lang=js"
export * from "./ClassFilterNav.vue?vue&type=script&lang=js"
import style0 from "./ClassFilterNav.vue?vue&type=style&index=0&id=a4e63876&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports